import { apiUrl } from "../../common/api/config";

export const getFiles = async () => {
  const response = await fetch(apiUrl + "/data_imports/files/", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch files");
  }

  return await response.json();
};

export const getFile = async (fileId) => {
  const response = await fetch(apiUrl + `/data_imports/files/${fileId}/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch file");
  }

  return await response.json();
};

export const uploadFile = async (file, data = {}) => {
  const formData = new FormData();
  formData.append("file", file);

  // Add other data fields
  Object.keys(data).forEach((key) => {
    if (data[key] !== undefined && data[key] !== null) {
      formData.append(key, data[key]);
    }
  });

  const response = await fetch(apiUrl + "/data_imports/files/", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
    body: formData,
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || "Failed to upload file");
  }

  return await response.json();
};

export const confirmColumnMappings = async (
  fileId,
  mappings,
  sourceLabel,
  defaultPeriodStart,
  defaultPeriodEnd,
) => {
  const response = await fetch(
    apiUrl + `/data_imports/files/${fileId}/confirm-mappings/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify({
        mappings,
        source_label: sourceLabel || "",
        default_period_start: defaultPeriodStart || "",
        default_period_end: defaultPeriodEnd || "",
      }),
    },
  );

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || "Failed to confirm column mappings");
  }

  return await response.json();
};

export const getExpectedFields = async () => {
  const response = await fetch(apiUrl + "/data_imports/expected-fields/", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch expected fields");
  }

  return await response.json();
};

export const getRemapData = async (fileId) => {
  const response = await fetch(
    apiUrl + `/data_imports/files/${fileId}/remap/`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    },
  );

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || "Failed to get remap data");
  }

  return await response.json();
};

export const updateFileContent = async (fileId, file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(apiUrl + `/data_imports/files/${fileId}/`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
    body: formData,
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || "Failed to update file");
  }

  return await response.json();
};

export const deleteFile = async (fileId) => {
  const response = await fetch(apiUrl + `/data_imports/files/${fileId}/`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to delete file");
  }

  return await response.json();
};
